import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tabs,
  Tab,
  Box,
  Typography,
} from '@mui/material';
import { Close as CloseIcon, LocationOn as LocationOnIcon } from '@mui/icons-material';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Leaflet ikon sorununu düzeltmek için genel çözüm
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

interface ShiftLocationModalProps {
  open: boolean;
  onClose: () => void;
  report: any; // Rapor verisini alacak
}

const ShiftLocationModal: React.FC<ShiftLocationModalProps> = ({ open, onClose, report }) => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const girisKonum = report?.originalRecord?.girisKonum;
  const cikisKonum = report?.originalRecord?.cikisKonum;

  const renderMap = (location: any, type: 'giriş' | 'çıkış') => {
    if (!location || !location.latitude || !location.longitude) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: 300 }}>
          <Typography variant="body1" color="text.secondary">
            {type === 'giriş' ? 'Giriş' : 'Çıkış'} için konum bilgisi bulunamadı.
          </Typography>
        </Box>
      );
    }

    const position: [number, number] = [location.latitude, location.longitude];
    const timestamp = location.timestamp ? new Date(location.timestamp).toLocaleString('tr-TR') : 'Bilinmiyor';

    return (
      <MapContainer center={position} zoom={16} style={{ height: '400px', width: '100%' }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker position={position}>
          <Popup>
            <b>{type === 'giriş' ? 'Giriş' : 'Çıkış'} Konumu</b><br />
            Personel: {report?.personnel}<br />
            Zaman: {timestamp}
          </Popup>
        </Marker>
      </MapContainer>
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Vardiya Konum Bilgisi
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabIndex} onChange={handleTabChange} variant="fullWidth">
            <Tab label="Giriş Konumu" icon={<LocationOnIcon />} iconPosition="start" />
            <Tab label="Çıkış Konumu" icon={<LocationOnIcon />} iconPosition="start" />
          </Tabs>
        </Box>
        <Box sx={{ p: 0 }}>
          {tabIndex === 0 && renderMap(girisKonum, 'giriş')}
          {tabIndex === 1 && renderMap(cikisKonum, 'çıkış')}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ShiftLocationModal;
